// Behåll orderkommentaren i kassan när sidan laddas om.
// WC sparar inte order_comments i sessionen, så fältet töms när Svea laddar om
// kassan (byte av betalsätt via "Andra betalsätt", nekat köp, nonce-förnyelse).
// Texten speglas till sessionStorage och läggs tillbaka i ett tomt fält vid
// sidladdning och efter updated_checkout. Rensas på tack-sidan.
(function () {
    const KEY = 'lw_order_comments'
    const SELECTOR = 'textarea[name="order_comments"]'

    function read() {
        try {
            return window.sessionStorage.getItem(KEY) || ''
        } catch (e) {
            return ''
        }
    }

    function write(value) {
        try {
            if (value.trim()) {
                window.sessionStorage.setItem(KEY, value)
            } else {
                window.sessionStorage.removeItem(KEY)
            }
        } catch (e) {}
    }

    function restore() {
        const saved = read()
        if (!saved) return

        document.querySelectorAll(SELECTOR).forEach((field) => {
            if (!field.value) field.value = saved
        })
    }

    function init() {
        if (document.body.classList.contains('woocommerce-order-received')) {
            write('')
            return
        }

        if (!document.body.classList.contains('woocommerce-checkout')) return

        restore()

        document.addEventListener('input', (e) => {
            if (e.target.matches && e.target.matches(SELECTOR)) {
                write(e.target.value)
            }
        })

        if (typeof jQuery !== 'undefined') {
            jQuery(document.body).on('updated_checkout', restore)
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }
})()
